// extracted by mini-css-extract-plugin
export default {"deleteModal":"DeleteClient_deleteModal__vVb0X"};